import { keepPreviousData, useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { VisitorParkingSessionModel } from '@/models'

export interface GetVisitorParkingSessionsRequest {
  buildingId: number
  skip?: number
  limit?: number
  fromDate?: number
  toDate?: number
  search?: string
}

export interface GetVisitorParkingSessionsResponse {
  total: number
  rows: Array<VisitorParkingSessionModel>
}

export const getVisitorParkingSessionsQueryKey = (data: GetVisitorParkingSessionsRequest) => [
  'useGetVisitorParkingSessions',
  data,
]

export const getVisitorParkingSessions = async (
  data: GetVisitorParkingSessionsRequest,
  signal?: AbortSignal,
) => {
  const response = await authAPI.get<GetVisitorParkingSessionsResponse>(
    '/visitor-parking/sessions',
    { params: data, signal },
  )
  return response.data
}

export const useGetVisitorParkingSessions = (data: GetVisitorParkingSessionsRequest) => {
  return useQuery({
    enabled: !!data.buildingId,
    placeholderData: keepPreviousData,
    queryFn: ({ signal }) => getVisitorParkingSessions({ ...data }, signal),
    queryKey: getVisitorParkingSessionsQueryKey(data),
  })
}
